// components/speaker/Speaker.js
import styles from './speaker.module.scss';

export const Speaker = ({
	speaker,
	index,
	isMobile,
	isActive,
	onToggle,
	onHover,
	onLeave,
}) => {
	if (!speaker) return null;

	return (
		<div
			className={`${styles.speakerCard} ${styles[speaker.theme] || ''}`}
			onClick={() => isMobile && onToggle(index)}
			onMouseEnter={() => !isMobile && onHover(index)}
			onMouseLeave={() => !isMobile && onLeave(index)}
		>
			<img
				className={`${styles.speakerImage} ${isActive ? styles.active : ''}`}
				src={isMobile ? speaker.imageMobile : speaker.image}
				alt='speaker'
			/>
			{isMobile && (
				<div
					className={`${styles.toggleWrapper} ${
						isActive ? styles.expanded : ''
					}`}
				>
					<div className={styles.toggleIcon}></div>
				</div>
			)}
			<div className={styles.speakerContentWrapper}>
				<div
					className={`${styles.speakerTitle} ${isActive ? styles.active : ''}`}
				>
					{isMobile && <div className={styles.speakerName}>{speaker.name}</div>}
					<label>{speaker.organization}</label>
					<p>{speaker.title}</p>
				</div>
			</div>
			<div
				className={`${styles.speakerDetails} ${isActive ? styles.active : ''}`}
				onClick={(e) => e.stopPropagation()}
			>
				<img className={styles.speakerHr} src={speaker.hr} alt='hr' />
				<div className={styles.speakerDetailText}>
					{[
						'specialties',
						'position',
						'education',
						'experience',
						'certification',
						'honors',
					].map((key) =>
						speaker[key]?.length > 0 ? (
							<div key={key}>
								<label>
									{
										{
											specialties: '專長',
											position: '現職',
											education: '學歷',
											experience: '經歷',
											certification: '學會與認證',
											honors: '榮譽',
										}[key]
									}
								</label>
								<ul>
									{speaker[key].map((item, i) => (
										<li key={i}>{item}</li>
									))}
								</ul>
							</div>
						) : null
					)}
				</div>
			</div>
		</div>
	);
};
